// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".members-package-list .service-items .van-cell{padding:10px 0;background-color:#f4f4f4}.members-package-list .service-items .van-cell .van-cell__title{text-align:left}", ""]);
// Exports
module.exports = exports;
